import Checkbox from './Checkbox';

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/atoms/Checkbox/index.js